module.exports = __webpack_public_path__ + "static/dashboard_intro_api@3x-e6ef4aeced1ca1846ed95799fc9ddf36.png";